(() => {
  const shopRoot =
    window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : '/';

  async function shopifyRequest(endpoint, body = null) {
    const options = {
      method: body ? 'POST' : 'GET',
      headers: {
        Accept: 'application/json'
      }
    };

    if (body) {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }

    const response = await fetch(shopRoot + endpoint, options);

    if (!response.ok) {
      let message = 'Shopify cart request failed.';

      try {
        const error = await response.json();
        message =
          error.description ||
          error.message ||
          message;
      } catch (e) {
        // Use generic message.
      }

      throw new Error(message);
    }

    return response.json();
  }

  async function getCart() {
    return shopifyRequest('cart.js');
  }

  function getDonationLines(cart, root) {
    const donationProductIds =
      root.dataset.donationProducts
        .split(',')
        .map(String);

    return cart.items.filter((item) =>
      donationProductIds.includes(String(item.product_id))
    );
  }

  async function removeExistingDonation(root) {
    const cart = await getCart();
    const donationLines = getDonationLines(cart, root);

    for (const line of donationLines) {
      await shopifyRequest('cart/change.js', {
        id: line.key,
        quantity: 0
      });
    }
  }

  function getVariantMap(root) {
    const script = root.querySelector(
      '[data-bwitc-variant-map]'
    );

    if (!script) {
      throw new Error('Donation variant map is missing.');
    }

    const rows = JSON.parse(script.textContent);

    const map = new Map();

    rows.forEach((variant) => {
      map.set(
        String(variant.cents),
        String(variant.id)
      );
    });

    return map;
  }

  function setBusy(root, busy) {
    root.classList.toggle('is-loading', busy);

    root
      .querySelectorAll('button')
      .forEach((button) => {
        button.disabled = busy;
      });
  }

  function setStatus(root, message) {
    const status = root.querySelector(
      '[data-bwitc-status]'
    );

    if (status) {
      status.textContent = message;
    }
  }

  async function refreshCart() {
    /*
     * If we're on the full /cart page, a reload is
     * the safest way of refreshing all cart sections.
     */
    const path = window.location.pathname.replace(
      /\/+$/,
      ''
    );

    if (path.endsWith('/cart')) {
      window.location.reload();
      return;
    }

    /*
     * Dawn cart drawer.
     *
     * Shopify's section-rendering mechanism returns
     * fresh HTML for the drawer and cart bubble.
     */
    try {
      const response = await fetch(
        shopRoot +
          '?sections=cart-drawer,cart-icon-bubble'
      );

      const sections = await response.json();

      const drawer =
        document.querySelector('cart-drawer');

      if (
        drawer &&
        typeof drawer.renderContents === 'function'
      ) {
        drawer.renderContents({
          id: 'bwitc-donation',
          sections: sections
        });

        return;
      }
    } catch (error) {
      console.warn(
        'Could not refresh cart drawer.',
        error
      );
    }

    /*
     * Fallback for non-Dawn themes.
     */
    window.location.reload();
  }

  async function addDonation(root, cents, mode) {
    const variantMap = getVariantMap(root);
    const variantId =
      variantMap.get(String(cents));

    if (!variantId) {
      throw new Error(
        `No donation variant exists for ${cents}p.`
      );
    }

    /*
     * Replace any existing donation rather
     * than stacking multiple donations.
     */
    await removeExistingDonation(root);

    await shopifyRequest('cart/add.js', {
      items: [
        {
          id: variantId,
          quantity: 1,
          properties: {
            _bwitc_donation: '1',
            _bwitc_donation_mode: mode,
            _bwitc_donation_value: String(cents)
          }
        }
      ]
    });
  }

  document.addEventListener(
    'click',
    async (event) => {
      const donationButton =
        event.target.closest(
          '[data-bwitc-donate]'
        );

      const noThanksButton =
        event.target.closest(
          '[data-bwitc-none]'
        );

      const button =
        donationButton || noThanksButton;

      if (!button) return;

      const root = button.closest(
        '[data-bwitc-donation]'
      );

      if (!root) return;

      setBusy(root, true);
      setStatus(root, '');

      try {
        if (noThanksButton) {
          await removeExistingDonation(root);
        } else {
          const cents = parseInt(
            donationButton.dataset.bwitcDonate,
            10
          );

          const mode =
            donationButton.dataset.bwitcMode ||
            'fixed';

          await addDonation(
            root,
            cents,
            mode
          );
        }

        await refreshCart();
      } catch (error) {
        console.error(error);

        setStatus(
          root,
          'Sorry, we could not update your donation. Please try again.'
        );

        setBusy(root, false);
      }
    }
  );
})();